"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useInViewport = ref => {
  const [isIntersecting, setIntersecting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!(ref !== null && ref !== void 0 && ref.current)) return;
    let previousY = 0;
    let previousRatio = 0;
    const observer = new IntersectionObserver(_ref => {
      let [entry] = _ref;
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;
      const isIntersecting = entry.isIntersecting;
      if (currentY < previousY) {
        if (currentRatio < previousRatio && !isIntersecting) {
          setIntersecting(true);
        }
      } else if (currentY > previousY && isIntersecting) {
        if (currentRatio > previousRatio) {
          setIntersecting(true);
        }
      }
      previousY = currentY;
      previousRatio = currentRatio;
      setIntersecting(false);
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
};
var _default = exports.default = useInViewport;